var React = require('react');

function CircleInline (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"611","cy":"110","r":"11","transform":"translate(-600 -99)"}));
}

CircleInline.defaultProps = {"viewBox":"0 0 22 22","fill":"#F49164"};

module.exports = CircleInline;

CircleInline.default = CircleInline;
